import React from "react";
import { AppleStoreBlackLarge, AppleStoreBlackMedium, AppleStoreBrandLarge, AppleStoreBrandMedium, AppleStoreWhiteLarge, AppleStoreWhiteMedium, GoogleStoreBlackLarge, GoogleStoreBlackMedium, GoogleStoreBrandLarge, GoogleStoreBrandMedium, GoogleStoreWhiteLarge, GoogleStoreWhiteMedium, HuaweiStoreBlackLarge, HuaweiStoreBlackMedium, HuaweiStoreBrandLarge, HuaweiStoreBrandMedium, HuaweiStoreWhiteLarge, HuaweiStoreWhiteMedium, SamsungStoreBlackLarge, SamsungStoreBlackMedium, SamsungStoreBrandLarge, SamsungStoreBrandMedium, SamsungStoreWhiteLarge, SamsungStoreWhiteMedium } from "./illustrations";
export const AppStoreButtons = {
  Apple: {
    Black: {
      Large: /*#__PURE__*/React.createElement(AppleStoreBlackLarge, null),
      Medium: /*#__PURE__*/React.createElement(AppleStoreBlackMedium, null)
    },
    Brand: {
      Large: /*#__PURE__*/React.createElement(AppleStoreBrandLarge, null),
      Medium: /*#__PURE__*/React.createElement(AppleStoreBrandMedium, null)
    },
    White: {
      Large: /*#__PURE__*/React.createElement(AppleStoreWhiteLarge, null),
      Medium: /*#__PURE__*/React.createElement(AppleStoreWhiteMedium, null)
    }
  },
  Google: {
    Black: {
      Large: /*#__PURE__*/React.createElement(GoogleStoreBlackLarge, null),
      Medium: /*#__PURE__*/React.createElement(GoogleStoreBlackMedium, null)
    },
    Brand: {
      Large: /*#__PURE__*/React.createElement(GoogleStoreBrandLarge, null),
      Medium: /*#__PURE__*/React.createElement(GoogleStoreBrandMedium, null)
    },
    White: {
      Large: /*#__PURE__*/React.createElement(GoogleStoreWhiteLarge, null),
      Medium: /*#__PURE__*/React.createElement(GoogleStoreWhiteMedium, null)
    }
  },
  Samsung: {
    Black: {
      Large: /*#__PURE__*/React.createElement(SamsungStoreBlackLarge, null),
      Medium: /*#__PURE__*/React.createElement(SamsungStoreBlackMedium, null)
    },
    Brand: {
      Large: /*#__PURE__*/React.createElement(SamsungStoreBrandLarge, null),
      Medium: /*#__PURE__*/React.createElement(SamsungStoreBrandMedium, null)
    },
    White: {
      Large: /*#__PURE__*/React.createElement(SamsungStoreWhiteLarge, null),
      Medium: /*#__PURE__*/React.createElement(SamsungStoreWhiteMedium, null)
    }
  },
  Huawei: {
    Black: {
      Large: /*#__PURE__*/React.createElement(HuaweiStoreBlackLarge, null),
      Medium: /*#__PURE__*/React.createElement(HuaweiStoreBlackMedium, null)
    },
    Brand: {
      Large: /*#__PURE__*/React.createElement(HuaweiStoreBrandLarge, null),
      Medium: /*#__PURE__*/React.createElement(HuaweiStoreBrandMedium, null)
    },
    White: {
      Large: /*#__PURE__*/React.createElement(HuaweiStoreWhiteLarge, null),
      Medium: /*#__PURE__*/React.createElement(HuaweiStoreWhiteMedium, null)
    }
  }
};
const AppStoreButtonView = ({
  element,
  wuiltContext
}) => {
  const values = element?.settings;
  const Link = wuiltContext?.base?.Link;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      width: "fit-content"
    }
  }, /*#__PURE__*/React.createElement(Link, {
    href: values?.action?.value,
    target: values?.action?.newTab ? "_blank" : undefined
  }, AppStoreButtons?.[values?.action?.type]?.[values?.design?.style][values?.design?.size]));
};
export { AppStoreButtonView };
//# sourceMappingURL=AppStoreButtonView.js.map